(function () {
  function getHeaderOffset() {
    // Mirrors category-jump-links.js: the fixed header only overlaps
    // content on mobile, so the sticky bar only needs to clear it there.
    if (window.innerWidth >= 769) return 0;

    var header = document.querySelector('.site-header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function setupBar(bar, root) {
    var visible = false;

    // `top` itself is the show/hide mechanism (see category.liquid for why
    // this replaced transform:translateY) — hidden always means a fixed,
    // comfortably-off-screen value, regardless of the header offset.
    function applyPosition() {
      bar.style.top = visible ? getHeaderOffset() + 'px' : '-200px';
    }

    // A plain scroll listener re-reading getBoundingClientRect() on every
    // tick, rather than IntersectionObserver — on iOS Safari the observer
    // can miss updates around momentum scrolling and address-bar show/hide
    // (which changes the viewport size without a new scroll event), leaving
    // the bar stuck visible after scrolling back up past the grid.
    var ticking = false;

    function updateVisibility() {
      ticking = false;
      // Fully scrolled past it (its bottom edge is above the viewport).
      // The scrollY>0 guard is a hard sanity check: a below-the-fold
      // section can never legitimately read as "already passed" while the
      // page hasn't scrolled at all.
      visible = window.scrollY > 0 && root.getBoundingClientRect().bottom <= 0;
      bar.classList.toggle('is-visible', visible);
      applyPosition();
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    }

    applyPosition();
    updateVisibility();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function init() {
    document.querySelectorAll('[data-category-sticky-bar]').forEach(function (bar) {
      var wrapper = bar.closest('.shopify-section');
      var root = wrapper ? wrapper.querySelector('.category-lineup') : null;
      if (!root) return;
      setupBar(bar, root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
